import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

export const PackagesNew = () => {
  const language = useSelector((state) => state.language.language);
  useEffect(() => {
    if (window.nz && typeof window.nz.init === "function") {
      window.nz.init();
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>{"Packages"}</title>

        <link rel="canonical" href={`https://travco.com/${language}/ibe`} />
        <meta name="description" content={""} />
        <meta property="og:title" content={""} />
        <meta property="og:description" content={""} />
        <meta name="twitter:title" content={""} />
        <meta name="twitter:description" content={""} />
        <link rel="stylesheet" href="css/news.css" />
        <style type="text/css">{`@media screen and  (max-width: 768px) {
    .rlr-product-filters__filters-wrapper .rlr-checkboxes {
        display: flex;
        justify-content: space-between;
        align-items: start;
        margin-top: 10px;
    }
        
}header{
 margin-bottom:70px;}
    .navigation.fixed-top{
        height: 70px;
            background-color: rgba(0, 0, 0, 0.8);
           
        }`}</style>
        <script
          src="https://ibe.travco.com/integration/v1/travcoegypt/embed.js"
          type="text/javascript"
        ></script>
      </Helmet>{" "}
      <div id="nz-planner"></div>
      {/* <div id="nz-planner" onload="nz.init()"></div> */}
    </>
  );
};
